/* eslint-disable @typescript-eslint/no-explicit-any */
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

import { OnBeforeAddProductProps } from '@/context/RestrictedAgeContext'
import { ClientModel } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'
import LinkSeeMore from '../components/LinkSeeMore'
import buildInteractions from '../utils/buildInteractions'
import useAnalytics from './useAnalytics'
import useBannersCtrls from './useBannersCtrls'
import useCategoryCtrls from './useCategoryCtrls'
import useProductCtrls from './useProductCtrls'
import useRedirectCtrls from './useRedirectCtrls'
import useSearchCtrls from './useSearchCtrls'

const useInteractions = ({
  clientConfig,
  router,
  onAddProduct,
  onBeforeAddProduct,
}: {
  clientConfig: ClientModel
  router: AppRouterInstance
  onAddProduct?: (val: any) => void
  onBeforeAddProduct?: (val: OnBeforeAddProductProps) => void | null
}) => {
  const { buildListInfo, sendEventViewCategory, sendEventSelectProduct } =
    useAnalytics()
  const { onSeeMore } = useCategoryCtrls()
  const { onClickSearch } = useSearchCtrls()
  const { onBannerClick, onBannerLoaded } = useBannersCtrls(clientConfig)
  const {
    favoriteService,
    onClickProduct,
    onClickProductPromoTag,
    onCarlessProduct,
    onInteractionProduct,
  } = useProductCtrls({
    sendEventSelectProduct,
    router,
    clientConfig,
  })

  const { onRedirect } = useRedirectCtrls(router)

  return buildInteractions({
    favoriteService,
    onClickProduct,
    onClickProductPromoTag,
    onAddProduct,
    onCarlessProduct,
    onInteractionProduct,
    onSeeMore,
    onClickSearch,
    buildListInfo,
    sendEventViewCategory,
    LinkSeeMore,
    onRedirect,
    onBannerClick,
    onBannerLoaded,
    onBeforeAddProduct,
  })
}
export default useInteractions
